import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
  This component wraps a dropdown filter and provides a visual indicator of the current filter state.
  It also provides a button to clear the filter.
*/
export const FilterButton = ({
  isFilterActive,
  onClear,
  children,
  testId
}) => {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: isFilterActive ? 'fill-field-hover' : 'fill-transparent-default',
    borderRadius: "100",
    paddingInlineEnd: "50",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Box, {
        children: children
      }), isFilterActive && /*#__PURE__*/_jsx(Box, {
        marginInlineStart: "-100",
        children: /*#__PURE__*/_jsx(Button, {
          "aria-label": I18n.text('academyComponents.topFilters.removeFilter'),
          "data-test-id": testId,
          onClick: onClear,
          padding: "200",
          paddingInlineStart: "100",
          use: "link",
          children: /*#__PURE__*/_jsx(RemoveIcon, {
            color: "icon-core-default",
            size: "100"
          })
        })
      })]
    })
  });
};